import React from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { ArrowBack, Close } from '@mui/icons-material';
import { Loader, NoItemsYet } from 'components';
import { FindLoad } from 'utils';

const ACTION = 'GET_SESSION_CORRECTIONS';

const formatTimestamp = (datetime) => moment(datetime).format('MM/DD/YYYY h:mma');

const CorrectionItem = ({ correction }) => (
    <div className="ch-item">
        <div className="ch-item-top">
            <span className="ch-user-name">{correction.user?.name || 'Unknown user'}</span>
            <span className="ch-date">{formatTimestamp(correction.datetime)}</span>
        </div>

        {correction.changes?.length > 0 && (
            <div className="ch-changes">
                {correction.changes.map((line, idx) => (
                    <p key={idx} className="ch-change-line">{line}</p>
                ))}
            </div>
        )}
    </div>
);

export const CorrectionHistory = ({ onBack, onClose }) => {
    const corrections = useSelector((state) => state.session.sessionCorrections) || [];
    const loading = FindLoad(ACTION);
    const total = corrections.length;

    const renderBody = () => {
        if (loading?.length) return <Loader />;
        if (total === 0) return <NoItemsYet text="No corrections recorded yet" />;
        return corrections.map((correction, i) => (
            <CorrectionItem key={correction.id || i} correction={correction} />
        ));
    };

    return (
        <div className="correction-history">
            <div className="ch-header">
                {onBack && (
                    <button type="button" className="ch-back-btn" onClick={onBack} aria-label="Back">
                        <ArrowBack fontSize="small" />
                    </button>
                )}
                <div className="ch-header-text">
                    <h3>Correction History</h3>
                    {loading?.length ?
                        <p></p>
                        :
                        <p>
                            {total} correction{total === 1 ? '' : 's'} recorded
                        </p>
                    }
                </div>
                {onClose && (
                    <button type="button" className="ch-close-btn" onClick={onClose} aria-label="Close">
                        <Close fontSize="small" />
                    </button>
                )}
            </div>

            <div className="ch-body">{renderBody()}</div>
        </div>
    );
};
